import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeauty = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.625 2C9.96995 1.9998 10.2497 2.27926 10.25 2.62419V21.375C10.2502 21.72 9.97077 21.9998 9.62582 22H4.625C4.28009 22.0002 4.00026 21.7207 4 21.3758V2.625C3.9998 2.28009 4.27929 2.00027 4.62419 2H9.625ZM17.125 4.5C17.4699 4.4998 17.7498 4.77926 17.75 5.12418V13.875H18.375C18.7199 13.8748 18.9997 14.1542 19 14.4992V21.375C19.0002 21.72 18.7207 21.9998 18.3758 22H12.125C11.78 22.0002 11.5003 21.7207 11.5 21.3758V14.5C11.4998 14.1551 11.7793 13.8752 12.1242 13.875H12.75V8.25C12.7522 6.17989 14.4299 4.50229 16.5 4.5H17.125ZM5.25 8.875V20.75H9V8.875H5.25ZM12.75 15.125V20.75H17.75V15.125H12.75ZM14 11.375V13.875H16.5V11.375H14ZM16.5 5.75C15.1201 5.75178 14.0017 6.87005 14 8.25V10.125H16.5V5.75ZM5.25 3.25V7.625H9V3.25H5.25Z",
		fill: "currentColor"
	})
});
export default SvgBeauty;
